module.exports = __webpack_public_path__ + "images/8040734e466f77572b99b7b1bf2b1a74.png";